// extracted by mini-css-extract-plugin
export default {"documents":"Documents_documents__CMEf2","list":"Documents_list__gqrfF","download":"Documents_download__yM3+x"};